import { ICTAData } from '../../elements/CTALink'
import { IProps as IImage } from '../../elements/Image'
import { AllSystemColors, mq, RichText, withMediaQuery } from '../../utils'
import { MultiFeatureSpotlight as MultiFeatureSpotlightPure } from './component-legacy'

export const MultiFeatureSpotlight = withMediaQuery(
  // @ts-ignore
  'isMobile',
  mq.mobile,
  MultiFeatureSpotlightPure,
)

export interface IProps {
  fullWidth?: boolean
  eyebrow?: string
  heading: string
  icon?: string
  bgColor: AllSystemColors
  slides: ISlide[]
  cta?: ICTAData
  isMobile: boolean
  bodyCopy?: string
}

export interface ISlide {
  text: RichText
  imageRef: IImage
  video?: string
  videoWebm?: string
}
